import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import { getPageProps } from "@services/initial-calls";
import { useDomainContext } from "@hooks/useDomainContext";
import SeveralBrandsWrapper from "@components/layouts/severalBrandsWrapper";
import { DomainInfo } from "@components/severalbrands/utils/services";
import B2bGeneralContainer from "@components/severalbrands/b2b/b2bGeneralContainer";

export default function SeveralBrandsCategoryPage(): ReactElement {
    const { domain } = useDomainContext();

    return (
        <SeveralBrandsWrapper domainInfo={domain as unknown as DomainInfo}>
            <B2bGeneralContainer />
        </SeveralBrandsWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "category", {
        slug: "b2b",
        getDomainMenus: true,
    });
};
